import { logError } from '@/src/logger';
import { NOT_SET, track } from '@/src/utils/tracking';
import { getScreenName } from './utilsTracking';

const productClicked = ({
  origin,
  shopId = NOT_SET,
  discount = NOT_SET,
  productIndex = NOT_SET,
  productSku = NOT_SET,
  productUnitPrice = NOT_SET,
  productUnitSalePrice = NOT_SET,
  landingId,
  landingTitle,
  landingType,
  rankType,
  listedInfo = 'subsidized',
  screenType = 'items_landing',
}) => {
  const EVENT_NAME = 'product.clicked';

  const getVendorRankType = () => {
    if (rankType === 'cpc') return 'True: premium_placements__cpc';
    if (rankType === 'cpp') return 'True: premium_placements__cpp';
    return 'False';
  };

  const getOriginEvent = () => {
    switch (origin) {
      case 'home':
        return {
          shopClickOrigin: 'home_channel',
          shopSponsoringPlacement: 'home:channel',
        };
      case 'homefood':
        return {
          shopClickOrigin: 'shop_list_channel',
          shopSponsoringPlacement: 'shop_list:channel',
        };
      case 'newsfeed':
        return {
          shopClickOrigin: 'newsfeed_channel',
          shopSponsoringPlacement: 'newsfeed:channel',
        };
      case 'shop_list_channel':
        return {
          shopClickOrigin: 'shop_list_channel',
          shopSponsoringPlacement: 'shop_list:channel',
        };
      default:
        return {
          shopClickOrigin: 'home_channel',
          shopSponsoringPlacement: 'home:channel',
        };
    }
  };

  try {
    const payload = {
      origin: getOriginEvent().shopClickOrigin,
      shopId,
      discount,
      productIndex,
      productSku,
      productUnitPrice,
      productUnitSalePrice,
      listedInfo,
      screenType,
      landingId,
      landingTitle,
      landingType,
      vendorSponsoring: getVendorRankType(),
      screenName: getScreenName(landingType),
      vendorSponsoringPlacement: getOriginEvent().shopSponsoringPlacement,
    };
    track(EVENT_NAME, payload, {
      logEventKey: `[${EVENT_NAME}]`,
      sendToLogs: true,
    });
  } catch (e) {
    logError(EVENT_NAME, e);
  }
};

export default productClicked;
